import React from "react";

// Peak Line mark — a green chart line that traces the silhouette of an M
// with a glowing apex dot. Sits inside an elevated dark tile so it has
// presence on the dark navbar/footer backgrounds.
export const Logo = ({ size = 32 }) => {
  const svgSize = Math.round(size * 0.78);
  return (
    <div className="flex items-center gap-2" data-testid="brand-logo">
      <div
        className="flex items-center justify-center rounded-md"
        style={{
          width: size,
          height: size,
          backgroundColor: "#161B22",
          border: "1px solid rgba(29,158,117,0.35)",
        }}
        aria-label="Meta Monk Ventures logo"
      >
        <svg
          width={svgSize}
          height={svgSize}
          viewBox="0 0 64 64"
          aria-hidden="true"
        >
          <path
            d="M10 48 L22 22 L32 36 L42 18 L54 48 Z"
            fill="#1D9E75"
            opacity="0.18"
          />
          <path
            d="M10 48 L22 22 L32 36 L42 18 L54 48"
            fill="none"
            stroke="#1D9E75"
            strokeWidth="5"
            strokeLinejoin="round"
            strokeLinecap="round"
          />
          <circle cx="42" cy="18" r="4" fill="#FFFFFF" />
        </svg>
      </div>
      <div className="leading-none">
        <span className="text-white text-base font-semibold tracking-tight">
          Meta Monk
        </span>{" "}
        <span className="text-[#1D9E75] text-base font-normal">Ventures</span>
      </div>
    </div>
  );
};
